var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Student",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-/-My-Account",
    transform: "translate(-984.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Sub",
    transform: "translate(960.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your-Subscription",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-medical",
    transform: "translate(1.000000, 3.000000)",
    fill: "#586179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2375,10.9375 L13.95,10.9375 L13.95,13.671875 C13.95,13.8876112 14.1234897,14.0625 14.3375,14.0625 L16.6625,14.0625 C16.8765103,14.0625 17.05,13.8876112 17.05,13.671875 L17.05,10.9375 L19.7625,10.9375 C19.9765103,10.9375 20.15,10.7626112 20.15,10.546875 L20.15,8.203125 C20.15,7.98738877 19.9765103,7.8125 19.7625,7.8125 L17.05,7.8125 L17.05,5.078125 C17.05,4.86238877 16.8765103,4.6875 16.6625,4.6875 L14.3375,4.6875 C14.1234897,4.6875 13.95,4.86238877 13.95,5.078125 L13.95,7.8125 L11.2375,7.8125 C11.0234897,7.8125 10.85,7.98738877 10.85,8.203125 L10.85,10.546875 C10.85,10.7626112 11.0234897,10.9375 11.2375,10.9375 Z M27.9,2.34375 C27.8962756,1.05089095 26.8575162,0.00375443706 25.575,0 L5.425,0 C4.14248382,0.00375443706 3.1037244,1.05089095 3.1,2.34375 L3.1,18.75 L27.9,18.75 L27.9,2.34375 Z M24.8,15.625 L6.2,15.625 L6.2,3.125 L24.8,3.125 L24.8,15.625 Z M30.225,20.3125 L18.4808438,20.3125 C18.445,21.2797852 17.7683281,21.875 16.895,21.875 L13.95,21.875 C13.0447031,21.875 12.3515625,21.0219727 12.3627031,20.3125 L0.775,20.3125 C0.346979319,20.3125 0,20.6622775 0,21.09375 L0,21.875 C0.00505404459,23.5987751 1.3900151,24.9949052 3.1,25 L27.9,25 C29.6099849,24.9949052 30.994946,23.5987751 31,21.875 L31,21.09375 C31,20.6622775 30.6530207,20.3125 30.225,20.3125 L30.225,20.3125 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.7659d40e.svg";
export { ForwardRef as ReactComponent };